<template>
    <div v-if="loadingHistory">
        <ProgressSpinner />
    </div>
    <DataTable v-else-if="history && history.length > 0" :value="history" stripedRows size="small" paginator :rows="5" :rowsPerPageOptions="[5, 10, 20]">
        <Column header="Serial Number">
            <template #body="{ data }">
                <sensor-button :sensor="{ serialNumber: data.serialNumber, type: data.sensorType }" />
            </template>
        </Column>
        <Column field="sensorType" header="Type" />
        <Column header="Start">
            <template #body="{ data }">
                {{ data.attachedDate && format(data.attachedDate, 'Pp') }}
                <small>( {{ formatDistanceToNow(data.attachedDate, { addSuffix: true }) }} )</small>
            </template>
        </Column>
        <Column header="End">
            <template #body="{ data }">
                <span v-if="data.detachedDate">
                    {{ format(data.detachedDate, 'Pp') }} <small>( {{ formatDistanceToNow(data.detachedDate, { addSuffix: true }) }} )</small>
                </span>
            </template>
        </Column>
    </DataTable>
</template>

<script lang="ts" setup>
import { useApi } from '@/api'
import { onMounted, ref } from 'vue'
import { format } from 'date-fns-tz'
import { formatDistanceToNow } from 'date-fns'
import type { MonitorSensorRecordV1 } from '@geckoal/gecko-api-client'
import SensorButton from '../buttons/SensorButton.vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressSpinner from 'primevue/progressspinner'

const loadingHistory = ref(false)
const history = ref<MonitorSensorRecordV1[] | undefined>()

const props = defineProps({
    monitorId: {
        type: String,
        required: true
    }
})

onMounted(async () => {
    fetchHistory()
})

const fetchHistory = async () => {
    try {
        loadingHistory.value = true
        const result = await useApi().getMonitorSensorHistoryV1({ monitorId: props.monitorId })
        history.value = result.history
    } finally {
        loadingHistory.value = false
    }
}

defineExpose({ fetchHistory })
</script>
